module.exports = __webpack_public_path__ + "media/images/membership-share-95e52d78ba5fafad6858a2cb7b8bc350.jpg";